// extracted by mini-css-extract-plugin
module.exports = {"mainWarp":"style_mainWarp__2Wh_G","contentWrap":"style_contentWrap__28Zs9"};